// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{ name: NonNullable<unknown> }} i
*/
export const guestList_declineGuestWithWaitlistInfo = (i) => `ℹ️ The next guest on the waitlist will automatically move up. ℹ️

Do you really want to mark "${i.name}" as Not Coming?`